import { useQuery, useMutation } from '@tanstack/react-query';
import { profilesService } from 'app/javascript/services/profiles';
import type { AttendanceHeatmapResponse } from 'app/javascript/services/profiles';

export const publicProfileKey = (slug: string) => ['public-profile', slug];
export const checkInHeatmapKey = (slug: string, companySlug: string) =>
  ['check-in-heatmap', slug, companySlug];

export function usePublicProfile(slug: string) {
  return useQuery({
    queryKey: publicProfileKey(slug),
    queryFn: () => profilesService.get(slug),
    enabled: !!slug,
  });
}

export function useUpdateProfile() {
  return useMutation({
    mutationFn: (params: Parameters<typeof profilesService.updateMe>[0]) =>
      profilesService.updateMe(params),
  });
}

export function useCheckInHeatmap(slug: string, companySlug: string) {
  return useQuery<AttendanceHeatmapResponse>({
    queryKey: checkInHeatmapKey(slug, companySlug),
    queryFn: () => profilesService.getCheckInHeatmap(slug, companySlug),
    enabled: !!slug && !!companySlug,
    staleTime: 5 * 60 * 1000,
  });
}
